import React from 'react';
import { LICENSE_LABELS } from '../../utils/licenseRelevance.generated';
import { matchStateName } from '../../utils/usStates';

export default function LicenseMatchBadges({ relevance }) {
  if (!relevance?.details) return null;
  return <div className="flex flex-wrap gap-2 my-2" aria-label="License fit">
    {relevance.details.filter((d) => d.requirement === 'required' && d.state).map((d) => {
      const credential = `${matchStateName(d.state) || d.state} ${LICENSE_LABELS[d.licenseType]} license`;
      const label = d.status === 'covered'
        ? d.reasonCode === 'REVIEWED_COMPACT_AUTHORITY' ? `${credential}: compact authority confirmed` : `Has ${credential}`
        : d.status === 'listed' ? `${credential} listed` : d.status === 'willing' ? `Willing to obtain ${credential}` : d.status === 'unwilling' ? `Not seeking ${credential}` : `${credential}: needs confirmation`;
      return <span key={d.licenseType} title={d.status === 'listed' ? 'Listed on your profile; active status has not been verified.' : `${d.reasonCode}. Credentialing clearance is still required.`}
        className={`rounded-full px-3 py-1 text-xs ${['covered', 'listed'].includes(d.status) ? 'bg-green-50 text-green-800' : 'bg-gray-100 text-gray-600'}`}>{label}</span>;
    })}
  </div>;
}
